import * as React from 'react'
import i18next from 'i18next'
import { Lozenge } from '../../../shared/webcomponents/react-wrappers/Lozenge'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import { CreditBalanceText } from '../creditBalance/CreditBalanceText'
import { ZapBotContext } from './ZapBotContext'
import { ZapBotModalPage } from './ZapBot'
import { CREDITS_COST } from '../../../shared/domain/credits/types.no-deps'
import type { CamelCaseFlags } from '../../../shared/cfg/flags.no-deps'

type ZapBotModalHeaderProps = {
    onBack: () => void
    onClose: () => void
    featureFlags: Pick<CamelCaseFlags, 'aiCredits'>
    page: ZapBotModalPage
    showBackButton: boolean
    title: Nullable<string>
    beta?: boolean
}

export function ZapBotModalHeader({
    onBack,
    onClose,
    page,
    featureFlags,
    showBackButton,
    title,
    beta,
}: ZapBotModalHeaderProps) {
    const { creditBalance, goToPage } = React.useContext(ZapBotContext)

    return (
        <div className="ZapBot_modal-header">
            <div className="ZapBot_modal-header-side-item">
                {showBackButton ? (
                    <button className="ZapBot_back-button" data-testid="zapbot-back-button" onClick={onBack}>
                        <zaptic-icon icon-name="arrow-down-bold" />
                    </button>
                ) : (
                    <button className="ZapBot_hide-modal-button" data-testid="zapbot-close-button" onClick={onClose}>
                        <zaptic-icon icon-name="arrow-down-bold" />
                    </button>
                )}
            </div>
            <div className="ZapBot_modal-header-main-item">
                <div className="ZapBot_modal-header-heading">
                    <ModalTitle page={page} title={title} beta={beta} />
                </div>
                {page === ZapBotModalPage.Main && featureFlags.aiCredits && (
                    <div className="ZapBot_modal-header-sub-heading">
                        <CreditBalanceText
                            creditBalance={creditBalance}
                            creditsCost={CREDITS_COST.aika}
                            testId="zapbot-header-credit-balance"
                            i18nKey="appcore:ZapBot.aiCredits"
                            hideIcon
                        />
                        <button
                            className="ZapBot_credits-info-button"
                            data-testid="zapbot-header-credits-info-button"
                            onClick={() => goToPage(ZapBotModalPage.CreditsInfo)}
                        >
                            <zaptic-icon class="ZapBot_credits-info-icon" icon-name="info"></zaptic-icon>
                        </button>
                    </div>
                )}
            </div>
            <div className="ZapBot_modal-header-side-item">
                {/* Empty for now but useful for keeping title centered */}
            </div>
        </div>
    )
}

type ModalTitleProps = {
    page: ZapBotModalPage
    title: Nullable<string>
    beta?: boolean
}

function ModalTitle({ page, title, beta }: ModalTitleProps) {
    if (title) {
        return <>{title}</>
    }

    if (page === ZapBotModalPage.CreditsInfo) {
        return <>{i18next.t('appcore:ZapBot.creditsInfoPageTitle')}</>
    }

    return (
        <>
            AI Knowledge Assistant
            {beta && <Lozenge label={i18next.t('appcore:common.beta')} color="teal" />}
        </>
    )
}
